import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useAppStore } from '@/dashboard/store/appStore';
import { isUserInProject } from '@/dashboard/utils/user/isUserInProject';

export function useMainLayout() {
  const router = useRouter();
  const appStore = useAppStore();

  const { project, currentUser, currentProjectUser, currentWorkspaceUser } = storeToRefs(appStore);

  const showSideMenu = computed(() => {
    if (currentUser.value) {
      if (router.currentRoute.value.name === 'directory' && !project.value) {
        return false;
      } else if (router.currentRoute.value.name === 'directory' && project.value?.allow_public) {
        return isUserInProject(project.value, currentUser.value.id);
      }

      return true;
    } else {
      return false;
    }
  });

  function loadInitData() {
    void new Promise((resolve, reject) => {
      try {
        appStore.loadCurrentUser().then(() => {
          appStore.loadWorkspaces().then(() => {
            resolve(true);
          });
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  loadInitData();

  return {
    showSideMenu: showSideMenu,
  };
}
